import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { Masonry } from '@leagueplatform/masonry';

export const MedicarePrescriptionPaymentPlanMasonrySection = () => (
  <StackLayout
    orientation="vertical"
    css={{
      maxWidth: '784px',
      marginBottom: '$two',
    }}
  >
    <Box style={{ width: '100%' }}>
      <Masonry rootNodeId="medicare-prescription-payment-plan$root" />
    </Box>
  </StackLayout>
);
